module.exports = __webpack_public_path__ + "static/media/block-white.d3f81f55.svg";